import { useTranslation } from 'react-i18next';
import { COMMERCIAL_SITE } from '@connexio/shared/constants';
import { Button } from '@/components/ui/button';
import { toTelHref } from '@/components/ui/phone-link';
import { Section, SectionHeading } from './Section';
import styles from './DevelopmentStatus.module.css';

export function DevelopmentStatus() {
  const { t } = useTranslation('marketing');
  const email = COMMERCIAL_SITE.contactEmail;
  const phone = COMMERCIAL_SITE.contactPhone;

  return (
    <Section id="status" tone="tint" labelledBy="status-title">
      <div className={styles.box}>
        <SectionHeading
          id="status-title"
          eyebrow={t('status.eyebrow')}
          title={t('status.title')}
          align="center"
        />
        <p className={styles.body}>
          {t('status.body')}
        </p>
        {/* Outline, not primary: the free trial is the page's one primary action. */}
        <div className={styles.stack}>
          <Button asChild variant="outline" size="lg">
            <a href="#enterprise">{t('status.form')}</a>
          </Button>
          {email ? (
            <Button asChild variant="outline" size="lg">
              <a href={`mailto:${email}`}>{t('status.email', { email })}</a>
            </Button>
          ) : null}
          {phone ? (
            <Button asChild variant="outline" size="lg">
              <a href={toTelHref(phone)}>{t('status.phone', { phone })}</a>
            </Button>
          ) : null}
        </div>
      </div>
    </Section>
  );
}
